import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { CenterBox, PageWrapper } from './style/common.style';
import { PhoneFrame } from '../../../assets/image';
import { ScreenLoading2 } from '../../../assets/image/screen';
import {
  WebParentsAttendance,
  WebParentsSns,
  WebParentsGPS,
  WebParentsHomework,
  WebParentsPay,
  WebParentsNotice,
} from '../../../assets/web';
import ParentsAmule from '../../../components/Application/parentsScreen/ParentsApp';
import { P as A } from '../../../components/Application/style/phone.style';

const P = {
  Wrapper: styled(PageWrapper)``,
  Box: styled(CenterBox)`
    width: 1200px;
    display: flex;
    justify-content: space-between;
  `,
  ImageBox: styled.div`
    position: relative;
    height: 720px;
    width: 500px;
    transform: translateX(-120px);
  `,
  Phone: styled.img`
    position: absolute;
    height: 720px;
    width: auto;
  `,
  Screen: styled.div`
    position: absolute;
    height: 720px;
    width: 468px;
    background-size: contain;
    background-repeat: no-repeat;

    &.parents {
      background-image: url(${ScreenLoading2});
      animation: 13s SixthScreen infinite;
    }
  `,
  Right: styled.div`
    height: 720px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-top: 150px;
  `,
  Title: styled.div``,
  Text: styled.div`
    color: ${({ theme }) => theme.green};
    font-size: 20px;
    margin-bottom: 8px;

    &.none {
      opacity: 0.7;
      margin: 0;
      font-size: 1rem;
      color: black;
      animation: twinkle 1.6s ease-in-out infinite;
    }
  `,
  IconBox: styled.div`
    height: 80%;
    width: 720px;
  `,
  IconLine: styled.div`
    display: flex;
    justify-content: space-between;
  `,
  Item: styled.div`
    width: 220px;
    margin-bottom: 34px;
  `,
  Icon: styled.img`
    margin-bottom: 26px;
  `,
  Desc: styled.div`
    line-height: 22px;
    color: rgba(0, 0, 0, 0.65);

    &.title {
      margin-bottom: 10px;
      font-size: 18px;
      color: #000;
    }
  `,
};

const ParentsApp: React.FC = () => {
  const { t } = useTranslation();

  return (
    <P.Wrapper id="p3">
      <P.Box>
        <A.Screen>
          <ParentsAmule />
          <A.Frame src={PhoneFrame} />
        </A.Screen>
        <P.Right>
          <P.Title>
            <P.Text>{t('home_parents_title')}</P.Text>
            <P.Text className="none">{t('click')}</P.Text>
          </P.Title>
          <P.IconBox>
            <P.IconLine>
              <P.Item>
                <P.Icon src={WebParentsAttendance} />
              </P.Item>
              <P.Item>
                <P.Icon src={WebParentsPay} />
              </P.Item>
              <P.Item>
                <P.Icon src={WebParentsNotice} />
              </P.Item>
            </P.IconLine>
            <P.IconLine>
              <P.Item>
                <P.Icon src={WebParentsHomework} />
              </P.Item>
              <P.Item>
                <P.Icon src={WebParentsSns} />
              </P.Item>
              <P.Item>
                <P.Icon src={WebParentsGPS} />
              </P.Item>
            </P.IconLine>
          </P.IconBox>
        </P.Right>
      </P.Box>
    </P.Wrapper>
  );
};

export default ParentsApp;
